import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChangePasswordComponent } from '@app/modules/authentication/change-password/change-password.component';
import { MultifactorAuthenticationComponent } from '@app/modules/authentication/multifactor-authentication/multifactor-authentication.component';
import { SignInSignUpLeftBarComponent } from '@app/modules/authentication/sign-in-sign-up-left-bar/sign-in-sign-up-left-bar.component';
import { BsFileUploadComponent } from '@app/modules/bs-file-upload/bs-file-upload.component';
import { ConfirmDialogComponent } from '@app/modules/confirm-dialog/confirm-dialog.component';
import { SuggestionComponent } from '@app/modules/connection/suggestion/suggestion.component';
import { SuggestedConnectionsComponent } from '@app/modules/home-page/components/suggested-connections/suggested-connections.component';
import { PostBsmodelComponent } from '@app/modules/home-page/post-bsmodel/post-bsmodel.component';
import { NotificationListComponent } from '@app/modules/notification/list/list.component';
import { ProfileStepperBarComponent } from '@app/modules/profile-stepper-bar/profile-stepper-bar.component';
import { EstateSharedFilesComponent } from '@app/modules/vault/components/search-results-view/estate-shared-files/estate-shared-files.component';
import { UserContactInformationComponent } from '@app/shared/component/user-contact-information/user-contact-information.component';
import { UserDeclinePermissionRequestComponent } from '@app/shared/component/user-decline-permission-request/user-decline-permission-request.component';
import { UserDeletePermissionRequestComponent } from '@app/shared/component/user-delete-permission-request/user-delete-permission-request.component';
import { UserEducationInformationComponent } from '@app/shared/component/user-education-information/user-education-information.component';
import { UserHomeInformationComponent } from '@app/shared/component/user-home-information/user-home-information.component';
import { UserWorkInformationComponent } from '@app/shared/component/user-work-information/user-work-information.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgOtpInputModule } from 'ng-otp-input';
import { AvatarModule } from 'ngx-avatars';
import { ImgFallbackModule } from 'ngx-img-fallback';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { LottieModule } from 'ngx-lottie';
import { MomentModule } from 'ngx-moment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ConnectRelationshipDialogComponent } from './component/connect-relationship-dialog/connect-relationship-dialog.component';
import { DeleteRequestComponent } from './component/delete-request/delete-request.component';
import { FileExpirationDateTagComponent } from './component/file-expiration-date-tag/file-expiration-date-tag.component';
import { GenderSelectorComponent } from './component/gender-changes/gender-selector.component';
import { LeftPopupMenuComponent } from './component/left-popup-menu/left-popup-menu.component';
import { LeftSidenavOfficeComponent } from './component/left-sidenav-professional/left-sidenav-office/left-sidenav-office.component';
import { LeftSidenavProfessionalComponent } from './component/left-sidenav-professional/left-sidenav-professional.component';
import { LeftSidenavRelationshipComponent } from './component/left-sidenav-professional/left-sidenav-relationship/left-sidenav-relationship.component';
import { LeftSidenavComponent } from './component/left-sidenav/left-sidenav.component';
import { LoaderComponent } from './component/loader/loader.component';
import { MobileAddButtonComponent } from './component/mobile-add-button/mobile-add-button.component';
import { MobileFileExpirationDateTagComponent } from './component/mobile-file-expiration-date-tag/mobile-file-expiration-date-tag.component';
import { MobileTopNavigationComponent } from './component/mobile-top-navigation/mobile-top-navigation.component';
import { NetworkEditConnectionComponent } from './component/network-edit-connection/network-edit-connection.component';
import { NetworkFloatActionComponent } from './component/network-float-action/network-float-action.component';
import { NetworkRejectRequestComponent } from './component/network-reject-request/network-reject-request.component';
import { NetworkRemoveConnectionComponent } from './component/network-remove-connection/network-remove-connection.component';
import { OfficeNavComponent } from './component/office-nav/office-nav.component';
import { ProfileLeftSideBarComponent } from './component/profile-left-sidebar/profile-left-sidebar.component';
import { ProfileSidebarComponent } from './component/profile-sidebar/profile-sidebar.component';
import { RelationshipRequestsComponent } from './component/relationship-requests/relationship-requests.component';
import { SharedConfirmationDialogComponent } from './component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { SharedLogoutComponent } from './component/shared-logout/shared-logout.component';
import { SmallButtonLoaderComponent } from './component/small-button-loader/small-button-loader.component';
import { UserEditPermissionComponent } from './component/user-edit-permission/user-edit-permission.component';
import { InviteConfirmationComponent } from './component/user-invite/dialogs/invite-confirmation/invite-confirmation.component';
import { InviteInformationComponent } from './component/user-invite/dialogs/invite-information/invite-information.component';
import { ProfToPersonalInviteComponent } from './component/user-invite/dialogs/prof-to-personal-invite/prof-to-personal-invite.component';
import { ProfToProfInviteComponent } from './component/user-invite/dialogs/prof-to-prof-invite/prof-to-prof-invite.component';
import { UserInviteComponent } from './component/user-invite/user-invite.component';
import { UserPermissionSelectComponent } from './component/user-permission-select/user-permission-select.component';
import { UserPermissionComponent } from './component/user-permission/user-permission.component';
import { UserRemoveAdminComponent } from './component/user-remove-admin/user-remove-admin.component';
import { OutsideDirective } from './directives/outside.directive';

import { MaterialModule } from './material/material.module';
import { ImageCropperModule } from './packages/image-cropper/image-cropper.module';
import { Pipes } from './pipes';
import { WelcomeProfessionalSerComponent } from './notification-user-license-popup/welcome-professional-ser/welcome-professional-ser.component';
import { FilterWorkspacePipe } from './pipes/filter-workspace.pipe';
import { SidenavSubmenuListComponent } from './component/sidenav-submenu-list/sidenav-submenu-list.component';
import { OfficeNetworkSidenavComponent } from './component/office-network-sidenav/office-network-sidenav.component';
import { FileDashboardStatusComponent } from './component/file-dashboard-status/file-dashboard-status.component';
import { VaultNavComponent } from './component/vault-nav/vault-nav.component';
import { AccessibilitySettingsComponent } from './component/accessibility-settings/accessibility-settings.component';
import { FileFolderTagComponent } from './component/file-folder-tag/file-folder-tag.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decima-number.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { LineChartComponent } from './component/graphs/line-chart/line-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { ScatterChartComponent } from './component/graphs/scatter-chart/scatter-chart.component';
import { DoughnutChartComponent } from './component/graphs/doughnut-chart/doughnut-chart.component';
import { PercentageIndicatorComponent } from './component/graphs/percentage-indicator/percentage-indicator.component';
import { AreaChartComponent } from './component/graphs/area-chart/area-chart.component';
import { ChartNameContainerComponent } from './component/graphs/chart-name-container/chart-name-container.component';
import { RelationshipRequestsV2Component } from './component/relationship-requests-v2/relationship-requests-v2.component';
import { NetworkRelationshipRequestsComponent } from './component/network-relationship-requests/network-relationship-requests.component';
import { CustomSearchComponent } from './component/custom-search/custom-search.component';
import { OfficeSearchDropdownComponent } from './component/custom-search/header-search-dropdown/office-search-dropdown/office-search-dropdown.component';
import { VaultSearchDropdownComponent } from './component/custom-search/header-search-dropdown/vault-search-dropdown/vault-search-dropdown.component';
import { RelationshipSearchDropdownComponent } from './component/custom-search/header-search-dropdown/relationship-search-dropdown/relationship-search-dropdown.component';
import { LoadingRelationshipCardComponent } from './component/sub-component/loading-relationship-card/loading-relationship-card.component';
import { NoInteractionsComponent } from './component/sub-component/no-interactions/no-interactions.component';
import { NoRelationshipsComponent } from './component/sub-component/no-relationships/no-relationships.component';
import { PermissionsTabComponent } from './component/sub-component/permissions-tab/permissions-tab.component';
import { RelationshipCardComponent } from './component/sub-component/relationship-card/relationship-card.component';
import { WorkspacesTabComponent } from './component/sub-component/workspaces-tab/workspaces-tab.component';
import { DoughnutComponent } from './component/sub-component/charts/doughnut/doughnut.component';
import { NetworkRelationshipRequestCardComponent } from './component/network-relationship-request-card/network-relationship-request-card.component';
import { BlockEmailDialogComponent } from './component/block-email-dialog/block-email-dialog.component';
import { MobileNetworkBarComponent } from './component/left-sidenav/mobile-network-bar/mobile-network-bar.component';
import { OfficeSideNavV2Component } from './component/office-side-nav-v2/office-side-nav-v2.component';
import { UserCustomSearchComponent } from './component/user-custom-search/user-custom-search.component';
import { SharedNoResultsComponent } from './component/shared-no-results/shared-no-results.component';
import { SharedDocViewerDialogComponent } from './component/shared-doc-viewer-dialog/shared-doc-viewer-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MobileCustomSearchComponent } from './component/custom-search/mobile-custom-search/mobile-custom-search.component';
import { MobileCustomSearchPopupComponent } from './component/custom-search/mobile-custom-search-popup/mobile-custom-search-popup.component';
import { DistributorTabComponent } from './component/sub-component/distributor-tab/distributor-tab.component';
import { AttachmentMoveDialogComponent } from './component/attachment-move-dialog/attachment-move-dialog.component';
import { ViewTemplateComponent } from './component/view-template/view-template.component';
import { FilterListPipe } from './pipes/filter-list.pipe';
import { FileExtensionComponent } from '@app/modules/vault/components/add-document/upload-ducoument/file-extension/file-extension.component';
import { SharedSectionCardComponent } from './component/shared-section-card/shared-section-card.component';
import { FilterIsHiddenPipe } from './pipes/filter-is-hidden.pipe';
import { FileExtensionPreviewComponent } from '@app/modules/vault/components/add-document/upload-ducoument/file-extension-preview/file-extension-preview.component';
import { MyInboxAttachMenuDialogComponent } from './component/my-inbox-attach-menu-dialog/my-inbox-attach-menu-dialog.component';
import { SelectUserFromNetworkComponent } from './component/select-user-from-network/select-user-from-network.component';
import { ViewChecklistTaskComponent } from './component/view-checklist-task/view-checklist-task.component';
import { ManageActivityLogComponent } from './component/manage-activity-log/manage-activity-log.component';
import { NgxEditorModule } from 'ngx-editor';
import { MyReportContainerComponent } from './component/my-report-container/my-report-container.component';
import { ReportCardNetworthComponent } from './component/my-report-container/report-card-networth/report-card-networth.component';
import { ReportTagComponent } from '@app/modules/reports/components/reports/report-tag/report-tag.component';
import { MyInboxHomeComponent } from './component/my-inbox-home/my-inbox-home.component';
import { NotificationListTwoComponent } from '@app/modules/notification/list-two/list-two.component';
import { AttachmentAttachDialogComponent } from './component/attachment-attach-dialog/attachment-attach-dialog.component';
import { WhiteListFeedbackDialogComponent } from './component/whitelist-feedback-dialog/whitelist-feedback-dialog.component';
import { SmallAssetMapChartComponent } from './component/my-report-container/report-card-networth/sub-component/small-asset-map-chart/small-asset-map-chart.component';
import { PocComponent } from '@app/modules/reports/components/poc/poc.component';
import { OrgChartModule } from 'angular13-organization-chart';
import { NodeComponent } from './component/my-report-container/report-card-networth/sub-component/small-asset-map-chart/node/node.component';
import { AreaNetworthChartComponent } from './component/graphs/line-chart/sub-component/area-networth-chart/area-networth-chart.component';
import { AssetLiabilitiesChartComponent } from './component/graphs/area-chart/sub-component/asset-liabilities-chart/asset-liabilities-chart.component';
import { SmallSankeyChartComponent } from './component/my-report-container/report-card-networth/sub-component/small-sankey-chart/small-sankey-chart.component';
import { TaskChecklistFloaterComponent } from './component/task-checklist-floater/task-checklist-floater.component';
import { AccountSetupComponent } from './component/account-setup/account-setup.component';
// import { DiscoveryComponent } from './component/discovery/discovery.component';
import { AddCategoryComponent } from './component/add-category/add-category.component';
import { LocationSettingsComponent } from './component/location-setting/location-settings.component';
import { InputNumberEffectComponent } from './component/input-effect/input-effect.component';
import { CommonProgressBarComponent } from './component/common-progress-bar/common-progress-bar.component';
import { AccountSetupNavComponent } from './component/account-setup-nav/account-setup-nav.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DiscoverySetupDetailsWrapperComponents } from './component/discovery-setup-detail/components-wrapper/components-wrapper';
import { DiscoveryWidgetComponent } from './component/discovery-setup-detail/widgets/widget/widget.component';
import { ConnectionModalComponent } from './component/connection-modal/connection-modal.component';
import { PathComponentConnectionComponent } from '@app/modules/home-page/components/path-component-connection/path-component-connection.component';
import { NgxEditorFieldComponent } from '@app/modules/vault/components/add-document/ngx-editor-field/ngx-editor-field.component';
import { MaintanceReminderListComponent } from './component/discovery-setup-detail/widgets/maintance-reminder-list/maintance-reminder-list.component';
import { OnboradingRminderListComponent } from './component/discovery-setup-detail/widgets/maintance-reminder-list/onborading-rminder-list/onborading-rminder-list.component';
import { SubCategoryCounterComponent } from './component/discovery/components/sub-category-counter/sub-category-counter.component';

import { ButtonSlideComponent } from './component/button-slide/button-slide.component';
import { UploadGatherComponent } from './component/discovery-setup-detail/widgets/upload-gather/upload-gather.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileListUploadComponent } from './component/discovery-setup-detail/widgets/upload-gather/sub-components/file-list-upload/file-list-upload.component';
import { SummaryScreenComponent } from './component/discovery-setup-detail/widgets/summary-setup-screen/sub-component/summary-screen/summary-screen.component';
import { SummarySetupScreenComponent } from './component/discovery-setup-detail/widgets/summary-setup-screen/summary-setup-screen.component';
import { StatusSetupGroupComponent } from './component/discovery-setup-detail/widgets/status-setup-group/status-setup-group.component';
import { LocationStatusScreenComponent } from './component/discovery-setup-detail/widgets/location-status-screen/location-status-screen.component';
import { FileListUploadV2MobileComponent } from './component/discovery-setup-detail/widgets/upload-gather/sub-components/file-list-upload-v2-mobile/file-list-upload-v2-mobile.component';
import { OBPromptsDialogComponent } from './component/ob-prompts-dialog/ob-prompts-dialog.component';
import { ConnectedUserCardComponent } from './component/connected-user-card/connected-user-card.component';
import { AddConnectionComponent } from './component/add-connection-component/add-connection.component';
import { ConnectionsSearchComponent } from './component/connections-search-component/connections-search.component';
import { RegisterTemplateComponent } from './component/register-template/register-template.component';
import { StepperManageContactListComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/stepper-manage-contact-list.component';
import { ManageAssociatedFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/manage-associated-form/manage-associated-form.component';
import { CreateAssociatedFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/create-associated-form.component';
import { ManageAssociatedOtherFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/manage-associated-other-form/manage-associated-other-form.component';
import { SelectTemplateAssociatedOtherFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/select-template-associated-other-form/select-template-associated-other-form.component';
import { AddVaultDialogComponent } from './component/add-vault-dialog/add-vault-dialog.component';
import { BooleanFlagFilterPipe } from './pipes/boolean-flag-filter.pipe';
import { FinancialAccountsAttributesComponent } from './component/discovery-setup-detail/widgets/financial-accounts-attributes/financial-accounts-attributes.component';
import { CreateMxConnectFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-mx-connect-form/create-mx-connect-form.component';
import { InsurancePoliciesWidgitComponent } from './component/discovery-setup-detail/widgets/insurance-policies-widgit/insurance-policies-widgit.component';
import { SearchExistingConnectionDroppdownComponent } from './component/search-existing-connection-dropdown/search-existing-connection-dropdown.component';
import { AttributesDialogComponent } from '@app/modules/vault/components/add-document/insurance-attributes/attributes-dialog/attributes-dialog.component';
import { IncomeExpenseDropdownComponent } from './component/income-expense-dropdown/income-expense-dropdown.component';
import { ManageUsersComponent } from './component/manage-element/manage-users/manage-users.component';
import { ManageTemplatesComponent } from './component/manage-element/manage-templates/manage-templates.component';
import { AddTrustTemplateDialogComponent } from './component/add-trust-template-dialog/add-trust-template-dialog.component';
import { ManageComboElementComponent } from './component/manage-element/manage-combo-element/manage-combo-element.component';
import { ManageTemplateTypeComponent } from './component/manage-element/manage-template-type/manage-template-type.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { SharedDropdownComponent } from './component/shared-dropdown/shared-dropdown.component';
import { CommonSuggestionViewComponent } from './component/common-suggestion-view/common-suggestion-view.component';
import { CurrentBalanceCardComponent } from './component/current-balance-card/current-balance-card.component';
import { GlobalSearchComponent } from '@app/layouts/main/global-search/global-search.component';
import { EditTemplateBasicFormComponent } from './component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { RegisterBalance2Component } from './component/register-balance-2/register-balance-2.component';
import { FilePreviewComponent } from '@app/layouts/main/global-search/file-preview/file-preview.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { LinkTemplateModelComponent } from './component/link-template-model/link-template-model.component';
import { EditLinkedFileComponent } from './component/link-template-model/edit-linked-file/edit-linked-file.component';
import { LinkedTemplateListComponent } from '@app/modules/vault/components/add-document/linked-templates/edit-add-linked-template-popup/linked-template-list/linked-template-list.component';
import { DynamicAttributesComponent } from './component/dynamic-attributes/dynamic-attributes.component';
import { DynamicAttributesDialogComponent } from './component/dynamic-attributes/dynamic-attributes-dialog/dynamic-attributes-dialog.component';
import { FileManagerComponent } from '@app/modules/vault/components/access-manager/file-manager.component';
import { ShareTypeControl } from '@app/modules/vault/components/share-type-control/share-type-control.component';
import { FormSetupSideBarComponent } from '@app/modules/on-boarding/form-setup-side-bar/form-setup-side-bar.component';
import { AttachFileContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/attach-file-container/attach-file-container.component';
import { DescriptionContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/description-container/description-container.component';
import { EditGeneralInformationContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/edit-general-information-container/edit-general-information-container.component';
import { SetupFinancialAttributesComponent } from '@app/modules/on-boarding/form-setup-side-bar/setup-financial-attributes/setup-financial-attributes.component';
import { SetupInsuranceAttributesComponent } from '@app/modules/on-boarding/form-setup-side-bar/setup-insurance-attributes/setup-insurance-attributes.component';
import { VaultEditContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/vault-edit-container/vault-edit-container.component';
import { AddVehicleBasicDetailsInfoComponent } from '@app/modules/vault/components/add-document/add-api-rapid-motor-value/add-edit-motor-value/add-vehicle-basic-details-info/add-vehicle-basic-details-info.component';
import { AddVehicleBasicDetailsInfoContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/api-continer/add-vehicle-basic-details-info-container/add-vehicle-basic-details-info-container.component';
import { VehicleLoaderComponent } from '@app/modules/vault/components/add-document/add-api-rapid-motor-value/add-edit-motor-value/vehicle-loader/vehicle-loader.component';
import { AddEditMotorValueComponent } from '@app/modules/vault/components/add-document/add-api-rapid-motor-value/add-edit-motor-value/add-edit-motor-value.component';
import { EditMxPlayerContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/api-continer/edit-mx-player-container/edit-mx-player-container.component';
import { EditMxPlayerComponent } from '@app/modules/vault/components/add-document/add-api-key-managed/edit-mx-player/edit-mx-player.component';
import { MxManageTemplatesComponent } from '@app/modules/vault/components/add-document/add-api-key-managed/edit-mx-player/mx-manage-templates/mx-manage-templates.component';
import { AddEditPropertyValueContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/add-edit-property-value-container/add-edit-property-value-container.component';
import { AddEditPropertyValueComponent } from '@app/modules/vault/components/add-document/add-api-rapid-property-value/add-edit-property-value/add-edit-property-value.component';
import { AttachmentSetupComponent } from './component/attachment-setup/attachment-setup.component';
import { NotesComponent } from '@app/modules/vault/components/add-document/notes/notes.component';
import { NotesListComponent } from '@app/modules/vault/components/add-document/notes/notes-list/notes-list.component';
import { ManageRolePlayersDialogComponent } from '@app/modules/vault/components/dialogs/manage-role-players-dialog/manage-role-players-dialog.component';
import { MobileDeliveryPortalComponent } from './component/attachment-setup/mobile-delivery-portal/mobile-delivery-portal.component';
import { ZeroStateMxDataComponent } from '@app/modules/vault/components/add-document/add-api-key-managed/edit-mx-player/zero-state-mx-data/zero-state-mx-data.component';
import { AskSecurityKeyPasswordComponent } from '@app/modules/vault/components/dialogs/ask-security-key-password/ask-security-key-password.component';
import { InaccessibleWallDialogComponent } from './component/inaccessible-wall-dialog/inaccessible-wall-dialog.component';
import { DateControlComponent } from './component/date-control/date-control.component';
import { TreeMapChartContainerComponent } from './component/graphs/doughnut-chart/tree-map-chart-container/tree-map-chart-container.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TemplateTransactionRegisterComponent } from './component/template-transaction-register/template-transaction-register.component';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { EditAddLinkedTemplatePopupComponent } from '@app/modules/vault/components/add-document/linked-templates/edit-add-linked-template-popup/edit-add-linked-template-popup.component';
import { ChecklistTaskComponent } from './component/checklist-task/checklist-task.component';
import { ChecklistOwnerListComponent } from './component/checklist-owner-list/checklist-owner-list.component';
import { TransactionFilterComponent } from '@app/modules/reports/components/transaction-filter/transaction-filter.component';
import { TaskItemDialogComponent } from '@app/modules/vault/components/dialogs/task-item-dialog/task-item-dialog.component';
import { MobileDeliveryListFileComponent } from '@app/modules/vault/components/add-document/create-attachemnt-popup/mobile-delivery-list-file/mobile-delivery-list-file.component';
import { AttachmentFloaterComponent } from './component/attachment-setup/floater/attachment-floater.component';
import { FilterDocumentPipe } from './component/attachment-setup/filter-document.pipe';
import { DirectDeliveryFileUploadComponent } from './component/attachment-setup/direct-delivery-file-upload/direct-delivery-file-upload.component';
import { NetworkSetupComponents } from './component/network-setup/components/components.components';
import { AboutMFOComponents } from './component/about-mfo/components/components.components';
import { EditReminderContainerComponent } from '@app/modules/on-boarding/form-setup-side-bar/edit-reminder-container/edit-reminder-container.component';
import { AddEditReminderModelComponent } from '@app/modules/vault/components/add-document/reminder-v2/reminder-v2/add-edit-reminder-model/add-edit-reminder-model.component';
import { ReminderCreationFormComponent } from '@app/modules/vault/components/add-document/reminder-v2/reminder-v2/add-edit-reminder-model/reminder-creation-form/reminder-creation-form.component';
import { ReminderSuggestionComponent } from '@app/modules/vault/components/add-document/reminder-v2/reminder-v2/add-edit-reminder-model/reminder-suggestion/reminder-suggestion.component';
import { SearchFilterPipe } from './pipes/filter-user-connection.pipe';
import { ManageGuardiansDialogComponent } from '@app/modules/vault/components/dialogs/manage-guardians-dialog/manage-guardians-dialog.component';
import { VaultSetupMembersComponent } from '@app/modules/on-boarding/vault-setup/vault-setup-members/vault-setup-members.component';
import { VaultSetupAdminComponent } from '@app/modules/on-boarding/vault-setup/vault-setup-admin/vault-setup-admin.component';
import { VaultSetupSharingComponent } from '@app/modules/on-boarding/vault-setup/vault-setup-sharing/vault-setup-sharing.component';
import { CheckListTaskAttachmentsComponent } from './component/checklist-task/check-list-task-attachments/check-list-task-attachments.component';
import { AddEntityVaultComponent } from '@app/modules/on-boarding/vault-setup/add-entity-vault/add-entity-vault.component';
import { VaultSetupLoadingComponent } from '@app/modules/on-boarding/vault-setup/vault-setup-loading/vault-setup-loading.component';
import { SecurityPrivacySetupComponent } from './component/security-privacy-setup/security-privacy-setup.component';
import { PremiumKeysComponent } from './component/security-privacy-setup/premium-keys/premium-keys.component';
import { AccountSetupInstructionComponent } from './component/account-setup/account-setup-instruction/account-setup-instruction.component';
import { FilePreviewSetupComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/file-preview-setup/file-preview-setup.component';
import { FormPreviewSetupWithNotesComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup-with-notes/form-preview-setup-with-notes.component';
import { OnboardingFormNameWidgetComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup-with-notes/onboarding-form-name-widget/onboarding-form-name-widget.component';
import { OnboardingFormNotesWidgetComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup-with-notes/onboarding-form-notes-widget/onboarding-form-notes-widget.component';
import { FormPreviewSetupComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup.component';
import { SetUpFormCreationComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/set-up-form-creation.component';
import { TemplateBasicFormComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/set-up-user-location-path/flow-component/sub-component/create-form-details-location/template-basic-form/template-basic-form.component';
import { AddPremiumKeyDialogComponent } from './component/security-privacy-setup/premium-keys/add-premium-key-dialog/add-premium-key-dialog.component';
import { ChecklistShortcutAddComponent } from './component/checklist-task/checklist-shortcut-add/checklist-shortcut-add.component';
import { CreateAccountPlaceholderComponent } from './component/create-account-placeholder/create-account-placeholder.component';
import { HelpCenterIconComponent } from './component/help-center-icon/help-center-icon.component';
import { MyInboxHomeZeroStateComponent } from './component/my-inbox-home-zero-state/my-inbox-home-zero-state.component';
import { MyInboxUploadFileComponent } from './component/my-inbox-upload-file/my-inbox-upload-file.component';
import { MyDeliveryComponent } from '@app/modules/my-delivery/my-delivery.component';
import { MyDeliveryHeaderComponent } from '@app/modules/my-delivery/sub-component/my-delivery-header/my-delivery-header.component';
import { ReuseableDateComponent } from './component/date-input/date-input.component';
import { ConnectionsSearchDialogComponent } from './component/connections-search-dialog/connections-search-dialog.component';
import { ReportCardEmptyStateComponent } from './component/my-report-container/report-card-empty-state/report-card-empty-state.component';
import { AddSecurityKeyComponent } from '@app/modules/vault/components/add-document/add-security-key/add-security-key.component';
import { NetworkResponsibilitiesComponent } from './component/network-setup/network-responsibilities/network-responsibilities.component';
import { MyResponsibilitiesComponent } from './component/network-setup/my-responsibilities/my-responsibilities.component';
import { CreateMiniFromStepperComponent } from './component/create-mini-from-stepper/create-mini-from-stepper.component';
import { DiscoveryCategoryConfiguration } from '@app/modules/on-boarding/discovery-category-configuration/discovery-category-configuration.component';
import { DiscoveryCategoryConfigSubType } from '@app/modules/on-boarding/discovery-category-configuration/discovery-category-config-subType/discovery-category-config-subType.component';
import { DiscoveryCategoryConfigQuestionsComponent } from '@app/modules/on-boarding/discovery-category-configuration/discovery-category-config-questions/discovery-category-config-questions.component';
import { DiscoveryCategoryConfigCompleteComponent } from '@app/modules/on-boarding/discovery-category-configuration/discovery-category-config-complete/discovery-category-config-complete.component';
import { AddDiscoverySubTypeDialogComponent } from '@app/modules/on-boarding/discovery-category-configuration/discovery-category-config-subType/add-discovery-subType-dialog/add-discovery-subType-dialog.component';
import { RemoveDiscoveryCategoryConfigComponent } from '@app/modules/on-boarding/discovery-category-configuration/remove-discovery-category-config/remove-discovery-category-config.component';
import { NetworkSuggestionsComponent } from './component/network-setup/network-suggestions/network-suggestions.component';
import { MutualConnectionComponent } from './component/network-setup/mutual-connection/mutual-connection.component';
import { ConnectUserComponent } from './component/connect-user/connect-user.component';
import { DiscoverySubTypeAddNewComponent } from '@app/modules/on-boarding/discovery-subType-Add-new/discovery-subType-Add-new.component';
import { IncompleteItemComponent } from './component/my-report-container/incomplete-item/incomplete-item.component';
import { AddDiscoveryCongfigFinanceComponent } from '@app/modules/on-boarding/discovery-category-configuration/add-discovery-congfig-finance/add-discovery-congfig-finance.component';
import { DiscoveryFinancialAccountAddNewComponent } from '@app/modules/on-boarding/discovery-financial-account-add-new/discovery-financial-account-add-new.component';
import { SubChartRangeComponent } from './component/graphs/doughnut-chart/sub-chart-range/sub-chart-range.component';
import { AddInstitutionComponent } from '@app/modules/vault/mx-component/dialog/add-institution/add-institution.component';
import { IndividualUserMemberComponent } from '@app/modules/vault/mx-component/dialog/add-institution/individual-user-member/individual-user-member.component';
import { ChecklistFloaterActionComponent } from '@app/modules/vault/components/common/common-file-view-with-groups/checklist-floater-action/checklist-floater-action.component';
import { VaultListNormalUserComponent } from '@app/modules/vault/components/vault-view/vault-list-normal-user/vault-list-normal-user.component';
import { DataTypesComponent } from '@app/modules/vault/components/data-types/data-types.component';
import { RootVaultViewDashboardComponent } from '@app/modules/vault/components/root-vault-view-dashboard/root-vault-view-dashboard.component';
import { CommonVaultSubHeaderComponent } from '@app/modules/vault/components/common/common-vault-sub-header/common-vault-sub-header.component';
import { VaultViewComponent } from '@app/modules/vault/components/vault-view/vault-view.component';
import { CommonTaskViewComponent } from '@app/modules/vault/components/common/common-task-view/common-task-view.component';
import { IndividualGroupFilesListItemsComponent } from '@app/modules/vault/components/common/common-file-view-with-groups/individual-group-files-list-items/individual-group-files-list-items.component';
import { EncryptionKeyContainerComponent } from '@app/modules/vault/container/encryption-key-container/encryption-key-container.component';
import { ManageSecuritykeyComponent } from '@app/modules/vault/components/securitykey/components/manage-securitykey/manage-securitykey.component';
import { SecurityComponent } from '@app/modules/vault/components/securitykey/container/security/security.component';
import { SelectWorkspaceMemberComponent } from './component/select-workspace-member/select-workspace-member.component';
import { WorkspacesCardComponent } from '@app/modules/home-page/components/workspaces-card/workspaces-card.component';
import { DiscoveryConfigurationComponent } from '@app/modules/on-boarding/discovery-configuration/discovery-configuration.component';
import { DiscoveryTemplateTableFormComponent } from '@app/modules/on-boarding/discovery-configuration/discovery-template-table-form/discovery-template-table-form.component';
import { DiscoveryConfigurationStatusComponent } from '@app/modules/on-boarding/discovery-configuration/discovery-configuration-status/discovery-configuration-status.component';
import { RenameInstitutionDialogComponent } from '@app/modules/on-boarding/discovery-configuration/rename-institution-dialog/rename-institution-dialog.component';
import { CreateFromWithVaultComponent } from './component/create-from-with-vault/create-from-with-vault.component';
import { BrowserRestrictionPageComponent } from '@app/modules/browser-restriction-page/browser-restriction-page/browser-restriction-page.component';
import { MoveFileItemComponent } from '@app/modules/vault/components/dialogs/move-file-item/move-file-item.component';
import { DiscoveryDataComponent } from '@app/modules/home-page/components/discovery-data/discovery-data.component';
import { DistributionCardComponent } from '@app/modules/vault/components/add-document/add-finacial-attribute/distribution/distribution-card.component';
import { DistributionRegisterComponent } from './component/distribution-register/distribution-register.component';
import { CapitalCommitmentCardComponent } from '@app/modules/vault/components/add-document/add-finacial-attribute/capital-commitment/capital-commitment-card.component';
import { TotalCommitmentDialog } from '@app/modules/vault/components/add-document/add-finacial-attribute/capital-commitment/total-commitment-dialog/total-commitment-dialog.component';
import { HomeSubjectService } from '@app/modules/home-page/container/home-subject.service';
import { ChatWidgetComponent } from './component/chat-widget/chat-widget.component';
import { ChatWidgetTemplateComponent } from './component/chat-widget-template/chat-widget-template.component';
import { ItemSetupSidebarContainerComponent } from '@app/modules/home-page/item-to-resolve-module/item-setup-sidebar-container/item-setup-sidebar-container.component';
import { ItemToResolveTemplatesComponent } from '@app/modules/home-page/item-to-resolve-module/item-setup-sidebar-container/item-to-resolve-templates/item-to-resolve-templates.component';
import { FloterActionItemToResolveComponent } from '@app/modules/home-page/item-to-resolve-module/item-setup-sidebar-container/floter-action-item-to-resolve/floter-action-item-to-resolve.component';
import { ManageTagsComponent } from './component/manage-tags/manage-tags.component';
import { AddTagDialogComponent } from './component/add-tag-dialog/add-tag-dialog.component';
import { HelpButtonComponent } from '@app/modules/home-page/components/help-button/help-button.component';
import { InboxPreviewComponent } from '@app/layouts/main/global-search/inbox-preview/inbox-preview.component';
import { AccountSecurityComponent } from '@app/modules/setting/components/account-security/account-security.component';
import { VaultLoadingComponent } from '@app/modules/vault/components/vault-view/vault-loading/vault-loading.component';
import { CommonRenameDialogComponent } from './components/common-rename-dialog/common-rename-dialog.component';
import { TemplateDocumentGridComponent } from '@app/modules/vault/components/common/common-file-view-with-groups/template-document-grid/template-document-grid.component';
import { MultiParentChartComponent } from './component/multi-parent-chart/multi-parent-chart.component';
import { UploadFileFloatBarComponent } from '@app/modules/my-delivery/sub-component/upload-file-float-bar/upload-file-float-bar.component';
import { ReportSideNavComponent } from '@app/modules/reports/components/reports/report-side-nav/report-side-nav.component';
import { ReportNameComponent } from '@app/modules/reports/components/reports/report-side-nav/report-name/report-name.component';
import { ReportFamilyMembersComponent } from '@app/modules/reports/components/reports/report-side-nav/report-family-members/report-family-members.component';
import { ReportVaultComponent } from '@app/modules/reports/components/reports/report-side-nav/report-vault/report-vault.component';
import { ReportVaultStatusComponent } from '@app/modules/reports/components/reports/report-side-nav/report-vault-status/report-vault-status.component';
import { CommonCreateAnimationLoaderComponent } from './component/common-create-animation-loader/common-create-animation-loader.component';
import { ReportSideNavManageNavComponent } from '@app/modules/reports/components/reports/report-side-nav/report-side-nav-manage-nav/report-side-nav-manage-nav.component';
import { FormsProgressbarChartComponent } from '@app/modules/vault/components/data-types/forms-progressbar-chart/forms-progressbar-chart.component';
import { DataSuggestionTypesComponent } from '@app/modules/vault/components/data-types/data-suggestion-types/data-suggestion-types.component';
import { ItemSuggestionAccordionComponent } from '@app/modules/vault/components/data-types/data-suggestion-types/item-suggestion-accordion/item-suggestion-accordion.component';
import { FloaterActionSuggestionComponent } from '@app/modules/vault/components/data-types/data-suggestion-types/floater-action-suggestion/floater-action-suggestion.component';
import { CommonFloaterActionComponent } from './component/common-floater-action/common-floater-action.component';
import { ManageRolePlayersOwnershipComponent } from '@app/modules/vault/components/add-document/role-players/manage-role-players-ownership/manage-role-players-ownership.component';
import { IndividualRolePlayersOwnershipViewComponent } from '@app/modules/vault/components/add-document/role-players/individual-role-players-ownership-view/individual-role-players-ownership-view.component';
import { FileSelectorComponent } from '@app/modules/vault/components/add-document/role-players/file-selector/file-selector.component';
import { RolePlayersOwnershipSummaryViewComponent } from '@app/modules/vault/components/add-document/role-players/role-players-ownership-summary-view/role-players-ownership-summary-view.component';
import { CommonOwnershipTableDropdownComponent } from '@app/modules/vault/components/add-document/role-players/common-ownership-table-dropdown/common-ownership-table-dropdown.component';
import { IndividualBeneficiariesSubcategoryViewComponent } from '@app/modules/vault/components/add-document/role-players/individual-beneficiaries-subcategory-view/individual-beneficiaries-subcategory-view.component';
import { RolePlayersBeneficiarySummaryViewComponent } from '@app/modules/vault/components/add-document/role-players/role-players-beneficiary-summary-view/role-players-beneficiary-summary-view.component';
import { AIVaultSelectionComponent } from './component/ai-vault-selection/ai-vault-selection.component';
import { UploadDocumentSelectionComponent } from './component/upload-document-selection/upload-document-selection.component';
import { AllAttributesSideDrawerComponent } from '@app/modules/home-page/components/all-attributes-side-drawer/all-attributes-side-drawer.component';
import { WorkspaceRequestSidenavComponent } from '@app/modules/home-page/home/workspace-request-sidenav/workspace-request-sidenav.component';
import { HomeObsService } from '@app/modules/home-page/home/home-obs.service';
import { CreateGroupDialogComponent } from '@app/modules/network/component/create-group-dialog/create-group-dialog.component';
import { DiscoveryHomeWidgetComponent } from '@app/modules/home-page/home/home-widgets/discovery-home-widget/discovery-home-widget.component';
import { HomeWidgetHeaderComponent } from '@app/modules/home-page/home/home-widgets/home-widget-header/home-widget-header.component';
import { MynetworkRequestsComponent } from '@app/modules/network/component/mynetwork-requests/mynetwork-requests.component';
import { VaultCardListComponent } from '@app/modules/home-page/home/vault-sidenav/vault-card-list/vault-card-list.component';
import { VaultStatusComponent } from '@app/modules/home-page/home/vault-sidenav/vault-status/vault-status.component';
import { MynetworkSuggestionsComponent } from '@app/modules/network/component/mynetwork-suggestions/mynetwork-suggestions.component';
import { VaultSuggestionSideNavComponent } from '@app/modules/vault/components/vault-suggestion-side-nav/vault-suggestion-side-nav.component';
import { VaultSuggestionAccordianTableComponent } from '@app/modules/vault/components/vault-suggestion-side-nav/vault-suggestion-accordian-table/vault-suggestion-accordian-table.component';
import { NetworkRegisterComponent } from '@app/modules/network/component/network-register/network-register.component';
import { DirectDeliverySidebarComponent } from '@app/layouts/main/global-search/direct-delivery-sidebar/direct-delivery-sidebar.component';
import { MyInboxUploadFileDirectDeliveryComponent } from './component/my-inbox-upload-file/my-inbox-upload-file-direct-delivery/my-inbox-upload-file-direct-delivery.component';
import { UploadDirectDeliveryComponent } from '@app/modules/upload-direct-delivery/upload-direct-delivery.component';
import { DirectDeliveryUploadBtnComponent } from '@app/layouts/main/global-search/direct-delivery-sidebar/direct-delivery-upload-btn/direct-delivery-upload-btn.component';
import { AiChatComponent } from '@app/modules/home-page/components/ai-chat/ai-chat.component';
import { AiChatDrawerComponent } from '@app/modules/home-page/components/ai-chat/ai-chat-drawer/ai-chat-drawer.component';
import { RenameDocumentNameComponent } from '@app/modules/inbox-v2/component/dialogs/rename-document-name/rename-document-name.component';
import { VaultFloaterActionComponent } from '@app/modules/vault/components/root-vault-view-dashboard/vault-floater/floater-action.component';
import { ManageVaultMembersComponent } from '@app/modules/vault/components/root-vault-view-dashboard/manage-vault-members/manage-vault-members.component';
import { CustomTooltipComponent } from '@app/shared/components/custom-tooltip/custom-tooltip.component';
import { CustomTooltipDirective } from './directives/custom-tooltip.directive';

const Modules = [FormsModule, ReactiveFormsModule, MaterialModule, CommonModule, NgChartsModule];

export function playerFactory() {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');
}

@NgModule({
  imports: [
    ...Modules,
    DragDropModule,
    MomentModule,
    NgApexchartsModule,
    RouterModule,
    NgOtpInputModule,
    OrgChartModule,
    ImgFallbackModule,
    ImageCropperModule,
    NgbModule,
    AutocompleteLibModule,
    InfiniteScrollModule,
    AvatarModule,
    CarouselModule,
    PdfViewerModule,
    NgxEditorModule,
    // LottieModule.forRoot({ player: playerFactory }),
    NgCircleProgressModule.forRoot({
      backgroundOpacity: 0,
      backgroundPadding: -50,
      radius: 20,
      space: -1,
      unitsFontWeight: '100',
      outerStrokeColor: '#c20000',
      innerStrokeColor: '#e49595',
      titleFontSize: '10',
      titleFontWeight: '100',
      subtitleFontWeight: '100',
      showTitle: false,
      showSubtitle: false,
      showUnits: false,
      showBackground: false,
      startFromZero: false,
      showZeroOuterStroke: false,
    }),
    IncomeExpenseDropdownComponent,
    MatSlideToggleModule,
    LottieComponent,
    MatIconModule,
    A11yModule,
    // CurrentBalanceCardComponent,
    AttachmentFloaterComponent,
    BrowserRestrictionPageComponent,
    // MoveFileItemComponent,
  ],
  declarations: [
    FileExpirationDateTagComponent,
    ProfileStepperBarComponent,
    SuggestedConnectionsComponent,
    ConfirmDialogComponent,
    SignInSignUpLeftBarComponent,
    SummarySetupScreenComponent,
    MyDeliveryComponent,
    UploadDirectDeliveryComponent,
    DirectDeliveryUploadBtnComponent,
    UploadFileFloatBarComponent,
    MyDeliveryHeaderComponent,
    RelationshipSearchDropdownComponent,
    EditAddLinkedTemplatePopupComponent,
    AddVehicleBasicDetailsInfoComponent,
    AddEditReminderModelComponent,
    ReminderSuggestionComponent,
    ReminderCreationFormComponent,
    VehicleLoaderComponent,
    Pipes,
    DoughnutComponent,
    OfficeSearchDropdownComponent,
    ProfileLeftSideBarComponent,
    ConnectRelationshipDialogComponent,
    VaultSearchDropdownComponent,
    CustomSearchComponent,
    BsFileUploadComponent,
    PostBsmodelComponent,
    UserInviteComponent,
    MobileDeliveryListFileComponent,
    LoaderComponent,
    FileExtensionComponent,
    FileExtensionPreviewComponent,
    DeleteRequestComponent,
    NetworkEditConnectionComponent,
    NetworkFloatActionComponent,
    NetworkRejectRequestComponent,
    NetworkRemoveConnectionComponent,
    UserPermissionComponent,
    UserPermissionSelectComponent,
    UserEditPermissionComponent,
    UserRemoveAdminComponent,
    UserDeclinePermissionRequestComponent,
    UserDeletePermissionRequestComponent,
    UserContactInformationComponent,
    UserWorkInformationComponent,
    UserEducationInformationComponent,
    UserHomeInformationComponent,
    SuggestionComponent,
    SharedConfirmationDialogComponent,
    OutsideDirective,
    TwoDigitDecimaNumberDirective,
    ClickOutsideDirective,
    SharedLogoutComponent,
    NotificationListComponent,
    RelationshipRequestsComponent,
    SmallButtonLoaderComponent,
    ChangePasswordComponent,
    MultifactorAuthenticationComponent,
    ProfileSidebarComponent,
    LeftSidenavComponent,
    GenderSelectorComponent,
    InviteConfirmationComponent,
    InviteInformationComponent,
    ProfToProfInviteComponent,
    ProfToPersonalInviteComponent,
    LeftSidenavProfessionalComponent,
    LeftSidenavOfficeComponent,
    LeftSidenavRelationshipComponent,
    OfficeNavComponent,
    MobileAddButtonComponent,
    MobileTopNavigationComponent,
    MobileFileExpirationDateTagComponent,
    LeftPopupMenuComponent,
    EstateSharedFilesComponent,
    WelcomeProfessionalSerComponent,
    FilterWorkspacePipe,
    SidenavSubmenuListComponent,
    NgxEditorFieldComponent,
    OfficeNetworkSidenavComponent,
    FileDashboardStatusComponent,
    RelationshipSearchDropdownComponent,
    OfficeSearchDropdownComponent,
    VaultSearchDropdownComponent,
    VaultNavComponent,
    RelationshipCardComponent,
    PermissionsTabComponent,
    WorkspacesTabComponent,
    NoInteractionsComponent,
    NoRelationshipsComponent,
    LoadingRelationshipCardComponent,
    SelectWorkspaceMemberComponent,
    AccessibilitySettingsComponent,
    FileFolderTagComponent,
    LineChartComponent,
    ScatterChartComponent,
    DoughnutChartComponent,
    PercentageIndicatorComponent,
    AreaChartComponent,
    ChartNameContainerComponent,
    RelationshipRequestsV2Component,
    NetworkRelationshipRequestsComponent,
    NetworkRelationshipRequestCardComponent,
    BlockEmailDialogComponent,
    MobileNetworkBarComponent,
    OfficeSideNavV2Component,
    UserCustomSearchComponent,
    SharedNoResultsComponent,
    SharedDocViewerDialogComponent,
    MobileCustomSearchComponent,
    MobileCustomSearchPopupComponent,
    DistributorTabComponent,
    AttachmentMoveDialogComponent,
    ViewTemplateComponent,
    FilterListPipe,
    SharedSectionCardComponent,
    FilterIsHiddenPipe,
    MyInboxAttachMenuDialogComponent,
    SelectUserFromNetworkComponent,
    ViewChecklistTaskComponent,
    ManageActivityLogComponent,
    MyInboxHomeComponent,
    MyReportContainerComponent,
    ReportTagComponent,
    ReportCardNetworthComponent,
    AttachmentAttachDialogComponent,
    WhiteListFeedbackDialogComponent,
    MyInboxHomeComponent,
    NotificationListTwoComponent,
    PocComponent,
    SmallAssetMapChartComponent,
    NodeComponent,
    AreaNetworthChartComponent,
    AssetLiabilitiesChartComponent,
    SmallSankeyChartComponent,
    // DiscoveryComponent,
    TaskChecklistFloaterComponent,
    InputNumberEffectComponent,
    AddCategoryComponent,
    AccountSetupComponent,
    LocationSettingsComponent,
    CommonProgressBarComponent,
    AccountSetupNavComponent,
    StatusSetupGroupComponent,
    ...DiscoverySetupDetailsWrapperComponents,
    SetUpFormCreationComponent,
    FilePreviewSetupComponent,
    FormPreviewSetupComponent,
    TemplateBasicFormComponent,
    DiscoveryWidgetComponent,
    ConnectionModalComponent,
    PathComponentConnectionComponent,
    FormPreviewSetupWithNotesComponent,
    OnboardingFormNotesWidgetComponent,
    MaintanceReminderListComponent,
    OnboradingRminderListComponent,
    SubCategoryCounterComponent,
    OnboardingFormNameWidgetComponent,
    ButtonSlideComponent,
    UploadGatherComponent,
    FileListUploadComponent,
    SummaryScreenComponent,
    LocationStatusScreenComponent,
    FileListUploadV2MobileComponent,
    OBPromptsDialogComponent,
    ConnectedUserCardComponent,
    AddConnectionComponent,
    ConnectionsSearchComponent,
    RegisterTemplateComponent,
    StepperManageContactListComponent,
    ManageAssociatedFormComponent,
    CreateAssociatedFormComponent,
    ManageAssociatedOtherFormComponent,
    SelectTemplateAssociatedOtherFormComponent,
    AddVaultDialogComponent,
    BooleanFlagFilterPipe,
    FinancialAccountsAttributesComponent,
    CreateMxConnectFormComponent,
    InsurancePoliciesWidgitComponent,
    SearchExistingConnectionDroppdownComponent,
    AttributesDialogComponent,
    ManageUsersComponent,
    ManageTemplatesComponent,
    AddTrustTemplateDialogComponent,
    ManageComboElementComponent,
    ManageTemplateTypeComponent,
    SharedDropdownComponent,
    DateControlComponent,
    CommonSuggestionViewComponent,
    CurrentBalanceCardComponent,
    // IncomeExpenseDropdownComponent,
    GlobalSearchComponent,
    EditTemplateBasicFormComponent,
    AddVehicleBasicDetailsInfoContainerComponent,
    RegisterBalance2Component,
    FilePreviewComponent,
    TooltipDirective,
    ClickOutsideDirective,
    AddEditMotorValueComponent,
    LinkedTemplateListComponent,
    EditLinkedFileComponent,
    LinkTemplateModelComponent,
    EditMxPlayerContainerComponent,
    EditMxPlayerComponent,
    FormSetupSideBarComponent,
    ZeroStateMxDataComponent,
    VaultEditContainerComponent,
    EditGeneralInformationContainerComponent,
    EditReminderContainerComponent,
    AskSecurityKeyPasswordComponent,
    AddEditPropertyValueComponent,
    DynamicAttributesComponent,
    AddEditPropertyValueContainerComponent,
    DynamicAttributesDialogComponent,
    AttachFileContainerComponent,
    FileManagerComponent,
    ShareTypeControl,
    DescriptionContainerComponent,
    MxManageTemplatesComponent,
    SetupInsuranceAttributesComponent,
    SetupFinancialAttributesComponent,
    AttachmentSetupComponent,
    NotesComponent,
    ManageRolePlayersDialogComponent,
    NotesListComponent,
    MobileDeliveryPortalComponent,
    InaccessibleWallDialogComponent,
    TreeMapChartContainerComponent,
    TemplateTransactionRegisterComponent,
    ChecklistTaskComponent,
    ChecklistOwnerListComponent,
    SearchFilterPipe,
    TransactionFilterComponent,
    TaskItemDialogComponent,
    FilterDocumentPipe,
    DirectDeliveryFileUploadComponent,
    ...NetworkSetupComponents,
    ...AboutMFOComponents,
    ManageGuardiansDialogComponent,
    VaultSetupMembersComponent,
    VaultSetupAdminComponent,
    VaultSetupSharingComponent,
    CheckListTaskAttachmentsComponent,
    AddEntityVaultComponent,
    VaultSetupLoadingComponent,
    SecurityPrivacySetupComponent,
    PremiumKeysComponent,
    AccountSetupInstructionComponent,
    AddPremiumKeyDialogComponent,
    ChecklistShortcutAddComponent,
    CreateAccountPlaceholderComponent,
    HelpCenterIconComponent,
    MyInboxHomeZeroStateComponent,
    MyInboxUploadFileComponent,
    ReuseableDateComponent,
    ConnectionsSearchDialogComponent,
    ReportCardEmptyStateComponent,
    AddSecurityKeyComponent,
    NetworkResponsibilitiesComponent,
    MyResponsibilitiesComponent,
    CreateMiniFromStepperComponent,
    DiscoveryCategoryConfiguration,
    DiscoveryCategoryConfigSubType,
    DiscoveryCategoryConfigQuestionsComponent,
    DiscoveryCategoryConfigCompleteComponent,
    AddDiscoverySubTypeDialogComponent,
    RemoveDiscoveryCategoryConfigComponent,
    NetworkSuggestionsComponent,
    MutualConnectionComponent,
    ConnectUserComponent,
    DiscoverySubTypeAddNewComponent,
    IncompleteItemComponent,
    AddDiscoveryCongfigFinanceComponent,
    DiscoveryFinancialAccountAddNewComponent,
    SubChartRangeComponent,
    AddInstitutionComponent,
    IndividualUserMemberComponent,
    VaultListNormalUserComponent,
    DataTypesComponent,
    RootVaultViewDashboardComponent,
    CommonVaultSubHeaderComponent,
    ChecklistFloaterActionComponent,
    VaultViewComponent,
    VaultLoadingComponent,
    IndividualGroupFilesListItemsComponent,
    CommonTaskViewComponent,
    ManageSecuritykeyComponent,
    SecurityComponent,
    EncryptionKeyContainerComponent,
    WorkspacesCardComponent,
    DiscoveryConfigurationComponent,
    DiscoveryTemplateTableFormComponent,
    DiscoveryConfigurationStatusComponent,
    RenameInstitutionDialogComponent,
    CreateFromWithVaultComponent,
    MoveFileItemComponent,
    DiscoveryDataComponent,
    ChatWidgetComponent,
    ChatWidgetTemplateComponent,
    DistributionCardComponent,
    DistributionRegisterComponent,
    CapitalCommitmentCardComponent,
    TotalCommitmentDialog,
    ItemSetupSidebarContainerComponent,
    ItemToResolveTemplatesComponent,
    FloterActionItemToResolveComponent,
    ManageTagsComponent,
    AddTagDialogComponent,
    HelpButtonComponent,
    InboxPreviewComponent,
    AccountSecurityComponent,
    CommonRenameDialogComponent,
    TemplateDocumentGridComponent,
    MultiParentChartComponent,
    ReportSideNavComponent,
    ReportNameComponent,
    ReportFamilyMembersComponent,
    ReportVaultComponent,
    ReportVaultStatusComponent,
    CommonCreateAnimationLoaderComponent,
    ReportSideNavManageNavComponent,
    FormsProgressbarChartComponent,
    DataSuggestionTypesComponent,
    ItemSuggestionAccordionComponent,
    FloaterActionSuggestionComponent,
    CommonFloaterActionComponent,
    ManageRolePlayersOwnershipComponent,
    IndividualRolePlayersOwnershipViewComponent,
    FileSelectorComponent,
    RolePlayersOwnershipSummaryViewComponent,
    CommonOwnershipTableDropdownComponent,
    IndividualBeneficiariesSubcategoryViewComponent,
    RolePlayersBeneficiarySummaryViewComponent,
    AIVaultSelectionComponent,
    UploadDocumentSelectionComponent,
    AllAttributesSideDrawerComponent,
    WorkspaceRequestSidenavComponent,
    CreateGroupDialogComponent,
    DiscoveryHomeWidgetComponent,
    HomeWidgetHeaderComponent,
    MynetworkRequestsComponent,
    VaultCardListComponent,
    VaultStatusComponent,
    MynetworkSuggestionsComponent,
    VaultSuggestionSideNavComponent,
    DirectDeliverySidebarComponent,
    VaultSuggestionAccordianTableComponent,
    RenameDocumentNameComponent,
    NetworkRegisterComponent,
    MyInboxUploadFileDirectDeliveryComponent,
    AiChatComponent,
    AiChatDrawerComponent,
    VaultFloaterActionComponent,
    ManageVaultMembersComponent,
    CustomTooltipComponent,
    CustomTooltipDirective,
  ],
  exports: [
    ...Modules,
    Pipes,
    NgApexchartsModule,
    DragDropModule,
    ReportTagComponent,
    MobileCustomSearchComponent,
    FileDashboardStatusComponent,
    MyInboxUploadFileComponent,
    MobileDeliveryListFileComponent,
    FormSetupSideBarComponent,
    ProfileLeftSideBarComponent,
    SmallButtonLoaderComponent,
    MyInboxHomeZeroStateComponent,
    AddVehicleBasicDetailsInfoComponent,
    CustomSearchComponent,
    UserCustomSearchComponent,
    AskSecurityKeyPasswordComponent,
    VaultListNormalUserComponent,
    DataTypesComponent,
    RootVaultViewDashboardComponent,
    CommonVaultSubHeaderComponent,
    SummarySetupScreenComponent,
    ReportCardNetworthComponent,
    AddEditReminderModelComponent,
    ReminderSuggestionComponent,
    ReminderCreationFormComponent,
    VehicleLoaderComponent,
    LinkedTemplateListComponent,
    AddEditMotorValueComponent,
    SuggestedConnectionsComponent,
    SignInSignUpLeftBarComponent,
    TreeMapChartContainerComponent,
    DoughnutComponent,
    ImageCropperModule,
    ConnectRelationshipDialogComponent,
    UserInviteComponent,
    PocComponent,
    RelationshipCardComponent,
    StatusSetupGroupComponent,
    PermissionsTabComponent,
    WorkspacesTabComponent,
    NoInteractionsComponent,
    NoRelationshipsComponent,
    LoadingRelationshipCardComponent,
    LoaderComponent,
    DeleteRequestComponent,
    NetworkEditConnectionComponent,
    NetworkFloatActionComponent,
    NetworkRejectRequestComponent,
    NetworkRemoveConnectionComponent,
    UserPermissionComponent,
    FileExtensionComponent,
    FileExtensionPreviewComponent,
    UserPermissionSelectComponent,
    UserEditPermissionComponent,
    UserRemoveAdminComponent,
    UserDeclinePermissionRequestComponent,
    UserDeletePermissionRequestComponent,
    MobileCustomSearchPopupComponent,
    UserContactInformationComponent,
    UserWorkInformationComponent,
    UserEducationInformationComponent,
    UserHomeInformationComponent,
    SelectUserFromNetworkComponent,
    SuggestionComponent,
    TwoDigitDecimaNumberDirective,
    ClickOutsideDirective,
    OutsideDirective,
    NotificationListComponent,
    MyReportContainerComponent,
    AvatarModule,
    RelationshipRequestsComponent,
    RelationshipRequestsV2Component,
    OfficeNavComponent,
    VaultNavComponent,
    MobileAddButtonComponent,
    MobileTopNavigationComponent,
    FileExpirationDateTagComponent,
    MobileFileExpirationDateTagComponent,
    LeftPopupMenuComponent,
    EstateSharedFilesComponent,
    SidenavSubmenuListComponent,
    OfficeNetworkSidenavComponent,
    FileFolderTagComponent,
    AccessibilitySettingsComponent,
    LineChartComponent,
    DoughnutChartComponent,
    ScatterChartComponent,
    PercentageIndicatorComponent,
    UploadGatherComponent,
    AreaChartComponent,
    ChartNameContainerComponent,
    NetworkRelationshipRequestsComponent,
    NetworkRelationshipRequestCardComponent,
    BlockEmailDialogComponent,
    MobileNetworkBarComponent,
    OfficeSideNavV2Component,
    SharedNoResultsComponent,
    SharedDocViewerDialogComponent,
    ViewTemplateComponent,
    AttachmentMoveDialogComponent,
    FilterListPipe,
    EditAddLinkedTemplatePopupComponent,
    SharedSectionCardComponent,
    FilterIsHiddenPipe,
    MyInboxAttachMenuDialogComponent,
    ViewChecklistTaskComponent,
    ManageActivityLogComponent,
    MyInboxHomeComponent,
    AttachmentAttachDialogComponent,
    WhiteListFeedbackDialogComponent,
    NotificationListTwoComponent,
    AttachFileContainerComponent,
    // DiscoveryComponent,
    TaskChecklistFloaterComponent,
    InputNumberEffectComponent,
    AddCategoryComponent,
    AccountSetupComponent,
    LocationSettingsComponent,
    CommonProgressBarComponent,
    DiscoveryWidgetComponent,
    ConnectionModalComponent,
    PathComponentConnectionComponent,
    NgxEditorFieldComponent,
    SubCategoryCounterComponent,
    ButtonSlideComponent,
    ManageAssociatedFormComponent,
    ...DiscoverySetupDetailsWrapperComponents,
    ConnectedUserCardComponent,
    AddConnectionComponent,
    ConnectionsSearchComponent,
    RegisterTemplateComponent,
    EditLinkedFileComponent,
    LinkTemplateModelComponent,
    FilePreviewSetupComponent,
    AttributesDialogComponent,
    SearchExistingConnectionDroppdownComponent,
    ManageUsersComponent,
    ManageTemplatesComponent,
    ManageComboElementComponent,
    ManageTemplateTypeComponent,
    MyDeliveryComponent,
    UploadDirectDeliveryComponent,
    DirectDeliveryUploadBtnComponent,
    UploadFileFloatBarComponent,
    MyDeliveryHeaderComponent,
    CommonSuggestionViewComponent,
    GlobalSearchComponent,
    SharedDropdownComponent,
    DateControlComponent,
    CommonSuggestionViewComponent,
    CurrentBalanceCardComponent,
    EditMxPlayerContainerComponent,
    EditMxPlayerComponent,
    ZeroStateMxDataComponent,
    RegisterBalance2Component,
    FilePreviewComponent,
    TooltipDirective,
    ClickOutsideDirective,
    VaultEditContainerComponent,
    // IncomeExpenseDropdownComponent,
    AddEditPropertyValueComponent,
    DynamicAttributesComponent,
    AddEditPropertyValueContainerComponent,
    DynamicAttributesDialogComponent,
    FileManagerComponent,
    ShareTypeControl,
    SearchFilterPipe,
    DescriptionContainerComponent,
    AddVehicleBasicDetailsInfoContainerComponent,
    SetupInsuranceAttributesComponent,
    MxManageTemplatesComponent,
    SetupFinancialAttributesComponent,
    EditTemplateBasicFormComponent,
    AttachmentSetupComponent,
    NotesComponent,
    ManageRolePlayersDialogComponent,
    MobileDeliveryPortalComponent,
    NotesListComponent,
    TemplateTransactionRegisterComponent,
    TransactionFilterComponent,
    DateControlComponent,
    TaskItemDialogComponent,
    ...NetworkSetupComponents,
    ...AboutMFOComponents,
    ManageGuardiansDialogComponent,
    VaultSetupMembersComponent,
    VaultSetupAdminComponent,
    VaultSetupSharingComponent,
    AddEntityVaultComponent,
    VaultSetupLoadingComponent,
    SecurityPrivacySetupComponent,
    MultifactorAuthenticationComponent,
    PremiumKeysComponent,
    AddPremiumKeyDialogComponent,
    CreateAccountPlaceholderComponent,
    HelpCenterIconComponent,
    ReuseableDateComponent,
    ReportCardEmptyStateComponent,
    ConnectionsSearchDialogComponent,
    AddSecurityKeyComponent,
    DiscoveryCategoryConfiguration,
    DiscoveryCategoryConfigSubType,
    DiscoveryCategoryConfigQuestionsComponent,
    DiscoveryCategoryConfigCompleteComponent,
    AddDiscoverySubTypeDialogComponent,
    RemoveDiscoveryCategoryConfigComponent,
    DiscoverySubTypeAddNewComponent,
    NetworkSuggestionsComponent,
    MutualConnectionComponent,
    ConnectUserComponent,
    AddDiscoveryCongfigFinanceComponent,
    DiscoveryFinancialAccountAddNewComponent,
    AddInstitutionComponent,
    IndividualUserMemberComponent,
    ChecklistFloaterActionComponent,
    IndividualGroupFilesListItemsComponent,
    VaultViewComponent,
    VaultLoadingComponent,
    CommonTaskViewComponent,
    EncryptionKeyContainerComponent,
    SecurityComponent,
    ManageSecuritykeyComponent,
    SelectWorkspaceMemberComponent,
    WorkspacesCardComponent,
    DiscoveryConfigurationComponent,
    DiscoveryTemplateTableFormComponent,
    DiscoveryConfigurationStatusComponent,
    RenameInstitutionDialogComponent,
    BrowserRestrictionPageComponent,
    DiscoveryDataComponent,
    ChatWidgetComponent,
    ChatWidgetTemplateComponent,
    DistributionCardComponent,
    DistributionRegisterComponent,
    CapitalCommitmentCardComponent,
    TotalCommitmentDialog,
    ManageTagsComponent,
    ItemSetupSidebarContainerComponent,
    ItemToResolveTemplatesComponent,
    FloterActionItemToResolveComponent,
    HelpButtonComponent,
    ProfileStepperBarComponent,
    InboxPreviewComponent,
    AccountSecurityComponent,
    TemplateDocumentGridComponent,
    MultiParentChartComponent,
    ReportSideNavComponent,
    ReportNameComponent,
    ReportFamilyMembersComponent,
    ReportVaultComponent,
    ReportVaultStatusComponent,
    CommonCreateAnimationLoaderComponent,
    ReportSideNavManageNavComponent,
    FormsProgressbarChartComponent,
    DataSuggestionTypesComponent,
    ItemSuggestionAccordionComponent,
    FloaterActionSuggestionComponent,
    CommonFloaterActionComponent,
    ManageRolePlayersOwnershipComponent,
    IndividualRolePlayersOwnershipViewComponent,
    FileSelectorComponent,
    RolePlayersOwnershipSummaryViewComponent,
    CommonOwnershipTableDropdownComponent,
    IndividualBeneficiariesSubcategoryViewComponent,
    RolePlayersBeneficiarySummaryViewComponent,
    AIVaultSelectionComponent,
    UploadDocumentSelectionComponent,
    AllAttributesSideDrawerComponent,
    WorkspaceRequestSidenavComponent,
    CreateGroupDialogComponent,
    DiscoveryHomeWidgetComponent,
    HomeWidgetHeaderComponent,
    MynetworkRequestsComponent,
    VaultCardListComponent,
    VaultStatusComponent,
    MynetworkSuggestionsComponent,
    VaultSuggestionSideNavComponent,
    VaultSuggestionAccordianTableComponent,
    RenameDocumentNameComponent,
    NetworkRegisterComponent,
    DirectDeliverySidebarComponent,
    MyInboxUploadFileDirectDeliveryComponent,
    AiChatComponent,
    AiChatDrawerComponent,
    VaultFloaterActionComponent,
    ManageVaultMembersComponent,
    CustomTooltipComponent,
    CustomTooltipDirective,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        provideLottieOptions({
          player: () => import('lottie-web'),
        }),
        HomeSubjectService,
        HomeObsService,
      ],
    };
  }
}
